module.exports = __webpack_public_path__ + "static/media/bevl-00.1764385f.jpg";